import React from "react";
import Select from "react-select";

type SelectInputProps = {
  options: Array<any>;
  className: string;
  defaultValue?:
    | { value: any; label: string }
    | { value: any; label: string }[]
    | null; // Allow both single and multi-select values
  isDisabled: boolean;
  isLoading: boolean;
  isClearable: boolean;
  isSearchable: boolean;
  isMulti: boolean;
  label: string;
  name: string;
  errors: any;
  onChange: Function;
  onMenuScrollToBottom?: any;
  onKeyDown?: any;
};

const SelectInput: React.FC<SelectInputProps> = ({
  options,
  className,
  defaultValue,
  isDisabled,
  isLoading,
  isClearable,
  isSearchable,
  isMulti,
  label,
  name,
  errors,
  onChange,
  onMenuScrollToBottom,
  onKeyDown,
}) => {
  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: !isDisabled ? "white" : "lightGray", // Replace "yourDesiredColor" with the desired background color
    }),
  };
  return (
    <div className="flex flex-col items-start">
      <label className="pb-1 ">{label}</label>
      <Select
        options={options}
        styles={customStyles}
        className={className}
        value={defaultValue}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isMulti={isMulti}
        name={name}
        onChange={(e) => onChange(e)}
        onMenuScrollToBottom={onMenuScrollToBottom}
        placeholder={"Select..."}
        onKeyDown={onKeyDown}
      />
      {errors && <p className="text-red-500 text-xs italic">{errors}</p>}
    </div>
  );
};

export default SelectInput;
